import { Button, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { CustomModalFooter } from 'src/components/custom_components/CustomModal';

import { I18NextNS } from 'src/models/Language.model';
import { EyesPosition } from 'src/models/Session.model';

import RetakeButton from './RetakeButton';

interface UngradableFooterProps {
  shouldShowDilationRecommendation: boolean;
  gradableEyesPosition: EyesPosition | undefined;
  onEndSession: () => void;
  onCompleteExam: () => void;
  onSaveAndDilate: () => void;
  handleRetake: (position: EyesPosition) => void;
  handleCloseAnalyzingProgressModal: () => void;
}

export default function UngradableFooter({
  shouldShowDilationRecommendation,
  gradableEyesPosition,
  onEndSession,
  onCompleteExam,
  onSaveAndDilate,
  handleRetake,
  handleCloseAnalyzingProgressModal,
}: UngradableFooterProps) {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModalFooter className="justify-content-between">
      <Stack direction="horizontal" gap={4} className="w-100">
        <Button
          variant="danger"
          data-track="exam.analyzing-modal.cancel-exam"
          data-test="analyzing-modal-cancel-exam"
          data-observe
          onClick={onEndSession}
        >
          {t('newExam.cancelExam')}
        </Button>
        <Stack direction="horizontal" gap={4} className="ms-auto">
          <Button
            variant="primary-100"
            data-track="exam.analyzing-modal.submit-anyway"
            data-test="analyzing-modal-submit-anyway"
            data-observe
            onClick={onCompleteExam}
          >
            {t('newExam.submitAnyway')}
          </Button>
          {shouldShowDilationRecommendation && (
            <Button
              variant="primary-100"
              data-track="exam.analyzing-modal.save-and-dilate"
              data-test="analyzing-modal-save-and-dilate"
              data-observe
              onClick={onSaveAndDilate}
            >
              {t('newExam.saveAndDilate')}
            </Button>
          )}
          <RetakeButton
            gradableEyesPosition={gradableEyesPosition}
            handleRetake={handleRetake}
            handleCloseAnalyzingProgressModal={
              handleCloseAnalyzingProgressModal
            }
          />
        </Stack>
      </Stack>
    </CustomModalFooter>
  );
}
